module.exports = __webpack_public_path__ + "static/media/Git.634d76fe.jpg";